import { Link, useLocation } from "react-router-dom";

const PublicNavbar = () => {
  const logout = () => {
    localStorage.removeItem("scouterToken");
    localStorage.removeItem("user");
    window.location.href = "/";
  };
  const location = useLocation();
  return (
    <nav className="bg-white shadow fixed w-full top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="btn btn-ghost text-xl">
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="50px"
                height="50px"
                viewBox="0 0 500.000000 500.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                <g
                  transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)"
                  fill="#000000"
                  stroke="none"
                >
                  <path
                    d="M2330 4994 c-499 -44 -906 -181 -1284 -431 -404 -268 -720 -675 -880
                  -1133 -46 -132 -86 -280 -77 -280 4 0 13 19 20 43 7 23 30 79 51 123 136 282
                  515 353 756 141 25 -22 57 -58 73 -81 38 -56 681 -1840 681 -1891 0 -35 -51
                  -72 -117 -85 -183 -36 -278 -75 -343 -140 -44 -44 -79 -110 -80 -147 l0 -23
                  373 0 c204 0 406 5 447 10 256 34 488 195 595 415 19 39 61 144 95 235 107
                  288 112 301 133 321 15 14 35 19 76 19 110 0 184 37 221 110 11 22 20 55 20
                  75 l0 35 -121 0 c-111 0 -121 2 -116 18 4 15 208 583 223 622 9 24 22 -9 167
                  -415 252 -708 339 -966 344 -1020 8 -79 -12 -167 -63 -272 -36 -75 -60 -108
                  -127 -176 -179 -182 -466 -329 -821 -422 -240 -63 -296 -69 -566 -69 -228 0
                  -254 1 -370 26 -711 153 -1283 658 -1519 1341 -49 143 -89 328 -98 451 -6 100
                  -22 152 -23 75 0 -83 20 -302 40 -424 90 -561 366 -1063 781 -1419 346 -297
                  795 -508 1246 -585 444 -75 865 -46 1275 89 653 215 1160 684 1436 1330 54
                  125 136 369 128 378 -3 2 -9 -4 -12 -14 -4 -10 -20 -52 -37 -93 -86 -212 -335
                  -335 -562 -276 -121 32 -242 120 -299 218 -14 23 -133 343 -266 712 -133 369
                  -273 758 -312 865 -76 210 -87 255 -69 288 17 32 53 47 171 71 192 41 298 110
                  345 227 l24 59 -292 6 c-347 8 -578 -2 -696 -31 -277 -67 -435 -262 -597 -733
                  -31 -93 -65 -178 -74 -190 -14 -16 -34 -22 -94 -28 -126 -12 -208 -80 -218
                  -179 l-3 -35 118 -3 c64 -1 117 -6 117 -11 0 -5 -11 -37 -24 -72 -55 -148
                  -196 -548 -196 -558 0 -30 -17 -4 -39 57 -12 37 -97 272 -188 522 -289 797
                  -285 785 -279 862 13 177 130 343 365 519 234 174 488 284 791 341 155 30 500
                  32 661 5 313 -53 596 -163 854 -332 299 -196 522 -445 680 -758 116 -231 188
                  -482 202 -704 3 -51 10 -93 14 -93 26 0 1 309 -41 520 -85 420 -239 779 -464
                  1075 -74 98 -256 287 -353 366 -347 285 -785 471 -1258 534 -116 16 -452 27
                  -545 19z"
                  />
                </g>
              </svg>
            </Link>
            <Link
              to="/games"
              className={`ml-8 text-gray-600 hover:text-gray-800 text-base font-medium ${
                location.pathname.startsWith("/games") ? "font-bold" : ""
              }`}
            >
              Lista de jogos
            </Link>
          </div>
          {/* Botão de logout à direita */}
          <div className="flex items-center">
            <div className="flex flex-col items-center">
              <a href="/" onClick={logout}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="32px"
                  width="32px"
                  viewBox="0 -960 960 960"
                  fill="#000000"
                >
                  <path d="M202.57-140q-25.79 0-44.18-18.39T140-202.57v-554.86q0-25.79 18.39-44.18T202.57-820h277.4v50.26h-277.4q-4.62 0-8.47 3.84-3.84 3.85-3.84 8.47v554.86q0 4.62 3.84 8.47 3.85 3.84 8.47 3.84h277.4V-140h-277.4Zm459.38-181.54-35.85-35.95 97.39-97.38H363.85v-50.26h358.82l-97.39-97.38 35.59-36.21L820-479.46 661.95-321.54Z" />
                </svg>
              </a>
              <div className="text-xs pt-[4px]">Sair</div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default PublicNavbar;
